/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { InscricaoPagamento } from '../models/inscricao-pagamento'
import { ErrorHandlerService } from './error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class InscricaoPagamentoService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  get(id: number): Observable<InscricaoPagamento> {
    return this.http
      .get<InscricaoPagamento>(`${this.baseUrl}/inscricao/pagamento/${id}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  confirmar(id: number): Observable<InscricaoPagamento> {
    return this.http
      .put<InscricaoPagamento>(`${this.baseUrl}/inscricao/pagamento/${id}/confirmar`, [])
      .pipe(identity, this.errorHandlerService.catchError())
  }

  cancelar(id: number): Observable<InscricaoPagamento> {
    return this.http
      .put<InscricaoPagamento>(`${this.baseUrl}/inscricao/pagamento/${id}/cancelar`, [])
      .pipe(identity, this.errorHandlerService.catchError())
  }

  concluir(id: number): Observable<InscricaoPagamento> {
    return this.http
      .put<InscricaoPagamento>(`${this.baseUrl}/inscricao/pagamento/${id}/concluir`, [])
      .pipe(identity, this.errorHandlerService.catchError())
  }

  salvarEdicao(id: number, pago: boolean | string) {
    if (pago.toString() === 'true' || pago == true) {
      return this.confirmar(id)
    } else {
      return this.cancelar(id)
    }
  }
}
